import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ApiService } from '../../../../../shared/services/api.service';
import { CommonService } from '../../../../../shared/services/common.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';




@Component({
  selector: 'app-update-event-date-list',
  templateUrl: './update-event-date-list.component.html',
  styleUrl: './update-event-date-list.component.css'
})
export class UpdateEventDateListComponent {
 constructor(private datePipe: DatePipe, public dialog: MatDialog, private apiService: ApiService,
    private router: Router, private toastrService: ToastrService, public commonService: CommonService) {

  }

dataSource: any[] = [];
totalRecords: number = 0;

pagination = {
  pageNumber: 1,
  pageSize: 10,
  searchTerm: '',
  sortColumn: 'CreatedOn',
  sortDirection: 'DESC'
};

searchTimeout: any;

ngOnInit() {
  this.loadData();
}


loadData() {
  this.apiService
    .getRequest(API_ENDPOINTS.MSSIDC.GETTOTALEVENTSDATELIST, this.pagination)
    .subscribe({
      next: (res: any) => {

        if (res && (res.status || res.Status)) {

          this.dataSource = res.data || [];
          this.totalRecords = res.totalRecords || 0;

          console.log('Bind Data:', this.dataSource);

        } else {
          this.dataSource = [];
          this.totalRecords = 0;
        }

      },
      error: (err) => {
        console.error(err);
        this.dataSource = [];
        this.totalRecords = 0;
      }
    });
}

// 📄 Pagination
onPageChange(event: any) {
  this.pagination.pageNumber = event.pageIndex + 1;
  this.pagination.pageSize = event.pageSize;
  this.loadData();
}

// 🔽 Sorting
sort(column: string) {
  if (this.pagination.sortColumn === column) {
    this.pagination.sortDirection =
      this.pagination.sortDirection === 'ASC' ? 'DESC' : 'ASC';
  } else {
    this.pagination.sortColumn = column;
    this.pagination.sortDirection = 'ASC';
  }

  this.pagination.pageNumber = 1;
  this.loadData();
}

// 🔍 Search (Debounce)
onSearchChange(value: string) {
  clearTimeout(this.searchTimeout);

  this.searchTimeout = setTimeout(() => {
    this.pagination.searchTerm = value;
    this.pagination.pageNumber = 1;
    this.loadData();
  }, 500);
}

onchangeDate() {


  this.router.navigate(['/Update-Event-Date']);


}

// 🔄 Reset
resetFilters() {
  this.pagination = {
    pageNumber: 1,
    pageSize: 10,
    searchTerm: '',
    sortColumn: 'CreatedOn',
    sortDirection: 'DESC'
  };

  this.loadData();
}

downloadFile(row: any) {
  const link = document.createElement('a');
  link.href = row.FilePath;
  link.download = row.FileName || 'file';
  link.target = '_blank';
  link.click();
}
}
